import _ from 'lodash'
import moment from 'moment'

import _t from 'utils/i18n_helper'


export const FETCHING_EVALUATION = 'FETCHING_EVALUATION'
export const FETCHED_EVALUATION = 'FETCHED_EVALUATION'
export const SAVE_EVALUATION = 'SAVE_EVALUATION'
export const SAVE_PARTIAL_EVALUATION = 'SAVE_PARTIAL_EVALUATION'
export const UPDATE_EVALUATION_PLANNING = 'UPDATE_EVALUATION_PLANNING'

export const EVALUATION_DROPDOWN_STATUS = [
  {
    key: 'not_evaluation_status',
    /*text: 'Any',*/
    text: _t('EVALUATION_STATUS_ANY_LABEL'),
    value: null,
  },
  {
    key: 'evaluation_sent',
    /*text: 'Pending',*/
    text: _t('EVALUATION_STATUS_PENDING_LABEL'),
    value: 2,
  },
  {
    key: 'evaluation_completed',
   /* text: 'Evaluated',*/
    text: _t('EVALUATION_STATUS_EVALUATED_LABEL'),
    value: 3,
  },
]

export function evaluation(evaluation={isFetching: false, data: []}, action) {
  switch(action.type) {
    case FETCHING_EVALUATION:
      return {
        isFetching: true,
        data: evaluation.data,
      }
    case SAVE_EVALUATION:
      return {
        isFetching: false,
        data: evaluation.data,
      }
    case SAVE_PARTIAL_EVALUATION:
      let hasEvaluation = _.findIndex(evaluation.data, { casnodeId: action.evaluation.casnodeId }) > -1,
          newEvaluation = (
            hasEvaluation ?
            _.map(evaluation.data, ev => {
              if (ev.casnodeId === action.evaluation.casnodeId) {
                return action.evaluation
              }
              return ev
            }) :
            [
              ...evaluation.data,
              action.evaluation,
            ]
          )

      return {
        isFetching: false,
        data: newEvaluation,
      }

    case UPDATE_EVALUATION_PLANNING:
      if (action.action === 'update') {
        return {
          ...evaluation,
          data: _.map(
            evaluation.data,
            evalu => {
              if (evalu.id === action.evaluation.id) {
                return {
                  ...action.evaluation,
                  date: moment.isMoment(action.evaluation.date) ? action.evaluation.date : moment(action.evaluation.date),
                }
              }
              return evalu
            }
          )
        }
      } else if (action.action === 'add') {
        return {
          ...evaluation,
          data: _.map(
            evaluation.data,
            evalu => {
              if (evalu.casnodeId === action.evaluation.casnodeId) {
                return {
                  ...action.evaluation,
                  date: moment.isMoment(action.evaluation.date) ? action.evaluation.date : moment(action.evaluation.date),
                }
              }
              return evalu
            }
          )
        }
      }
      break


    case FETCHED_EVALUATION:
      return {
        isFetching: false,
        data: action.evaluation,
      }
    default:
      return evaluation
  }
}
